import React from "react";
import DefaultAvatar from "../../../assets/images/DefaultAvatar.png";
import { ReactComponent as AwardIconColor } from "../../../assets/svgs/AwardIconColor.svg";
import { ReactComponent as ExpierienceIcon } from "../../../assets/svgs/ExpierienceIcon.svg";
import { ReactComponent as LocationBlueIcon } from "../../../assets/svgs/LocationBlueIcon.svg";
import { ReactComponent as OfficeBuilding } from "../../../assets/svgs/OfficeBuilding.svg";
import { doctorSpecialties } from "../../../constants/doctorSpecialties";
import { getSingleCountryLabel } from "../../../helper/country-helper";
import { getArrayLanguageLabels } from "../../../helper/language-helper";
import { Button } from "../../ui/button";

const DoctorDetailsHeader = ({
  doctor,
  showButton = false,
  buttonText = "",
  onButtonClick,
}) => {
  return (
    <div className="flex flex-col gap-4 sm:gap-6 w-full">
      <div className="flex border border-solid border-[#E7E8E9] rounded-xl w-full hover:bg-[#0052FD08] flex-col p-3 sm:p-4 md:p-5">
        <div className="flex flex-col gap-2">
          <div className="flex flex-col sm:flex-row items-start gap-4">
            <div className="w-full sm:w-auto flex justify-center sm:justify-start mb-3 sm:mb-0">
              <div className="w-20 h-20 sm:w-24 sm:h-24 md:w-32 md:h-32 rounded-2xl overflow-hidden border border-solid border-[#0052FD]">
                {doctor?.profilePicture?.url ? (
                  <img
                    alt="Doctor"
                    src={doctor.profilePicture.url}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = DefaultAvatar;
                    }}
                  />
                ) : (
                  <div className="w-full h-full bg-gray-200 flex items-center justify-center">
                    <span className="text-gray-500 text-xs">No Image</span>
                  </div>
                )}
              </div>
            </div>

            <div className="flex-1 flex flex-col gap-3 sm:gap-4 ">
              <div className="flex flex-col sm:flex-row items-center sm:items-start justify-between gap-3">
                <h1 className="font-semibold text-sm sm:text-base md:text-lg lg:text-xl text-center sm:text-left">
                  {`${doctor?.firstName || ""} ${doctor?.lastName || ""}`.trim() ||
                    "Unknown Doctor"}
                </h1>

                {/* <div className="h-7 w-7 sm:h-8 sm:w-8 flex items-center justify-center border border-solid border-[#E7E8E9] rounded-full flex-shrink-0">
                  <ShareBlue className="w-3 h-3 sm:w-4 sm:h-4" />
                </div> */}
              </div>

              <div className="flex flex-col lg:flex-row items-start justify-between gap-4">
                <div className="w-full lg:w-7/12 flex flex-col gap-2 sm:gap-3">
                  <h4 className="font-medium text-xs sm:text-sm md:text-base text-[#1E1E1EB2] text-center sm:text-left">
                    {doctor?.qualifications?.map((qual, idx) => (
                      <span key={qual.id || idx}>
                        {qual.degreeName}
                        {idx < doctor.qualifications.length - 1 ? ", " : ""}
                      </span>
                    ))}
                  </h4>

                  <div className="flex flex-col sm:flex-row items-center sm:items-start gap-2 sm:gap-4 flex-wrap">
                    {doctor?.speciality?.slice(0, 2).map((specialty, index) => {
                      const specialtyData = doctorSpecialties.find(
                        (item) => item.name === specialty,
                      );
                      const SpecialtyIcon = specialtyData?.Icon;

                      return (
                        <div
                          key={index}
                          className="flex items-center gap-1 sm:gap-2"
                        >
                          {SpecialtyIcon && (
                            <SpecialtyIcon className="w-4 h-4 sm:w-5 sm:h-5 text-primary" />
                          )}
                          <h1 className="font-medium text-xs sm:text-sm md:text-base text-[#1E1E1EB2]">
                            {specialty}
                          </h1>
                        </div>
                      );
                    })}
                  </div>

                  <div className="flex flex-col sm:flex-row items-center sm:items-start gap-2 sm:gap-4 flex-wrap">
                    <div className="flex items-center gap-1">
                      <h2 className="font-bold text-xs sm:text-sm md:text-base text-[#1E1E1EB2]">
                        Language:{" "}
                        <span className="font-medium">
                          {getArrayLanguageLabels(doctor?.language) ||
                            "Not specified"}
                        </span>
                      </h2>
                    </div>
                    <div className="flex items-center gap-1 sm:gap-2">
                      <LocationBlueIcon className="w-4 h-4 sm:w-5 sm:h-5" />
                      <h1 className="font-bold text-xs sm:text-sm md:text-base text-[#1E1E1EB2]">
                        {getSingleCountryLabel(
                          doctor?.country?.value || doctor?.country,
                        ) || "Location not specified"}
                      </h1>
                    </div>
                  </div>
                </div>

                <div className="w-full lg:w-5/12 flex flex-col gap-2 sm:gap-3 items-start lg:items-start mt-3 sm:mt-0">
                  <div className="flex items-center gap-2 w-full">
                    <div className="h-7 w-7 sm:h-8 sm:w-8 flex items-center justify-center border border-solid border-[#E7E8E9] rounded-full flex-shrink-0">
                      <ExpierienceIcon className="w-3 h-3 sm:w-4 sm:h-4" />
                    </div>
                    <h4 className="font-medium text-xs sm:text-sm md:text-base text-[#1E1E1E]">
                      {`${doctor?.yearsOfExperience || 0} Years Experience`}
                    </h4>
                  </div>
                  <div className="flex items-center gap-2 w-full">
                    <div className="h-7 w-7 sm:h-8 sm:w-8 flex items-center justify-center border border-solid border-[#E7E8E9] rounded-full flex-shrink-0 mt-0.5">
                      <OfficeBuilding className="w-3 h-3 sm:w-4 sm:h-4" />
                    </div>
                    <div className="flex-1">
                      <h4 className="font-medium text-xs sm:text-sm md:text-base text-[#1E1E1E] break-words">
                        {doctor?.qualifications?.length > 0
                          ? doctor.qualifications.map((qual, idx) => (
                              <span key={qual.id || idx}>
                                {qual.institutionName}
                                {idx < doctor.qualifications.length - 1
                                  ? ", "
                                  : ""}
                              </span>
                            ))
                          : "No institution specified"}
                      </h4>
                    </div>
                  </div>

                  {/* <div className="flex items-center gap-2 w-full">
                    <div className="h-7 w-7 sm:h-8 sm:w-8 flex items-center justify-center border border-solid border-[#E7E8E9] rounded-full flex-shrink-0">
                      <ThumbUp className="w-3 h-3 sm:w-4 sm:h-4" />
                    </div>
                    <h4 className="font-medium text-xs sm:text-sm md:text-base text-[#1E1E1E]">
                      95% Recommended
                      <span className="text-red-600 font-bold">
                        {" "}
                        (Hard Coded)
                      </span>
                    </h4>
                  </div> */}
                </div>
              </div>
            </div>
          </div>

          <div className="border-b border-solid border-[#E7E8E9] mx-2 sm:mx-4 my-2" />
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 p-2 sm:p-3">
            <div className="flex items-center flex-wrap gap-4 sm:gap-8">
              {/* <div className="flex items-center gap-2 mb-3 sm:mb-0">
                <div className="h-7 w-7 sm:h-8 sm:w-8 flex items-center justify-center border border-solid border-[#E7E8E9] rounded-full">
                  <CalendarIcon className="w-3 h-3 sm:w-4 sm:h-4" />
                </div>
                <h4 className="font-bold text-xs sm:text-sm md:text-base text-[#1E1E1E]">
                  200+ Appointments Booked{" "}
                  <span className="text-red-600 font-bold"> (Hard Coded)</span>
                </h4>
              </div> */}
              <div className="flex items-center gap-2 mb-3 sm:mb-0">
                <div className="h-7 w-7 sm:h-8 sm:w-8 flex items-center justify-center border border-solid border-[#E7E8E9] rounded-full">
                  <AwardIconColor className="w-3 h-3 sm:w-4 sm:h-4" />
                </div>
                {doctor?.awards?.length > 0 && (
                  <h4 className="font-bold text-xs sm:text-sm md:text-base text-[#1E1E1E]">
                    {doctor.awards.length > 1
                      ? `${doctor.awards.length - 1}+ awards`
                      : `${doctor.awards.length} award`}
                  </h4>
                )}
              </div>
              {/* <div className="flex items-center gap-2 mb-3 sm:mb-0">
                <div className="h-7 w-7 sm:h-8 sm:w-8 flex items-center justify-center border border-solid border-[#E7E8E9] rounded-full">
                  <ReviewIcon className="w-3 h-3 sm:w-4 sm:h-4" />
                </div>
                <h4 className="font-bold text-xs sm:text-sm md:text-base text-[#1E1E1E]">
                  5.0{" "}
                  <span className="text-gray-400 font-normal">
                    120 Review{" "}
                    <span className="text-red-600 font-bold">
                      {" "}
                      (Hard Coded)
                    </span>
                  </span>
                </h4>
              </div> */}
            </div>
            {showButton && (
              <Button
                variant="primary"
                className="w-full sm:w-auto"
                onClick={onButtonClick}
              >
                {buttonText}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoctorDetailsHeader;
